import { IQuery, Topics } from '@zaplify/common';
import { ProspectDto } from '../prospects';

export class GetProspectsByLinkedinUserIdsQuery extends IQuery<Record<string, ProspectDto>> {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly userId: string, readonly organizationIds: string, readonly linkedinUserIds: string[]) {
        super();
    }
}
